// extracted by mini-css-extract-plugin
module.exports = {"main":"dropdown_main__2y7IC","trigger":"dropdown_trigger__S_jlj","dropdownRender":"dropdown_dropdownRender__CxUfP","search":"dropdown_search__LAAw8","li":"dropdown_li__4swja"};